import { AnyAction, CombinedState, Reducer } from "redux";
import IAppState from "./IAppState";
import storageSession from 'redux-persist/lib/storage/session';
import { PersistConfig } from 'redux-persist/es/types';
import { persistReducer } from 'redux-persist';

const persistConfig: PersistConfig<CombinedState<IAppState>> = {
  key: 'root',
  storage: storageSession,
  whitelist: ['marketingConsents'/*, 'contracting'*/]
};

export const configuredPersistReducer = (rootReducer: Reducer<CombinedState<IAppState>, AnyAction>) => {
  return persistReducer(persistConfig, rootReducer);
};